import { useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import qs from "qs";

export default function useScannedPickup({ ready, onScan }) {
  const location = useLocation();
  const history = useHistory();

  const handled = useRef(new Set());

  const onScanRef = useRef(onScan);
  useEffect(() => {
    onScanRef.current = onScan;
  }, [onScan]);

  useEffect(() => {
    const { bookingId } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });

    if (typeof bookingId !== "string" || !bookingId) return;
    /* The facility arrives a render or two after the route does, and the write
     * needs it. Leave the param in place and run on the next pass. */
    if (!ready) return;
    if (handled.current.has(bookingId)) return;

    /* Claimed before the write, and the param stripped with it: a refresh or a
     * back-button mid-flight must not fire the mutation a second time. */
    handled.current.add(bookingId);
    history.replace(location.pathname);

    Promise.resolve(onScanRef.current(bookingId)).then((accepted) => {
      if (!accepted) handled.current.delete(bookingId);
    });
  }, [location.search, location.pathname, ready, history]);
}
